module.exports = __webpack_public_path__ + "img/Apple_logo_black.c665db1c.svg";